module.exports = __webpack_public_path__ + "img/responsible-citizen.5fc218dd.svg";